module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// ./~/_core-js@1.2.7@core-js/library/modules/$.redefine.js
// module id = 76
// module chunks = 0